import { ChecksumAddress } from '@silo/types';
import { getIsSiloDeprecated } from './isSiloDeprecated';
import { useMemo } from 'react';
import { useQueryReadyFallbackMarkets } from '../../../queries/markets/fallbackMarkets';
import { useSiloWeb3 } from '@silo/web3';

export const useIsSiloDeprecated = (siloAddress: ChecksumAddress) => {
  const { data: fallbackMarkets } = useQueryReadyFallbackMarkets();
  const { protocolKey } = useSiloWeb3();
  const marketIds = useMemo(() => fallbackMarkets?.map((market) => market.id), [fallbackMarkets]);

  const result = getIsSiloDeprecated(
    protocolKey,
    siloAddress,
    marketIds
      ? {
          ids: marketIds,
          getIsMarketArchived: (id) => fallbackMarkets?.find((market) => market.id === id)?.archived ?? false,
        }
      : undefined
  );

  if (result.isDeprecated && result.newSilo) {
    const market = fallbackMarkets?.find((market) => market.id === result.newSilo);

    return { isDeprecated: true, newSilo: market };
  }

  return { isDeprecated: result.isDeprecated };
};
